import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

import Status from '../Status';
import ContentWrap from '../ContentWrap';
import { getAsset } from '../../../util/assets';

const ErrorView = ({ location }) => (
  <Fragment>
    <Helmet>
      <title>Error &ndash; Waldo</title>
    </Helmet>

    <Status status={404}>
      <div className="wrapper-main">
        <div className="content-wrap content-wrap-gray">
          <ContentWrap size="sm">
            <div className="text-center">
              <h2 className="mb-3">Whoops!</h2>
              <img
                width="100px"
                src={getAsset('/waldo-icon-error.svg')}
                alt="Confused Waldo Icon"
                className="mb-3"
              />

              <p className="text-muted m-0">
                {(location.state && location.state.error) ||
                  'An unexpected error has occurred'}
              </p>
            </div>
          </ContentWrap>
        </div>
      </div>
    </Status>
  </Fragment>
);

ErrorView.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      error: PropTypes.string,
    }),
  }).isRequired,
};

export default ErrorView;
